import { darkTheme, lightTheme } from './tokens.js';
function mapThemeOf(theme) {
    const land = theme.colorNeutralBackground2;
    const park = theme.colorPaletteForestBackground2;
    const road = theme.colorNeutralBackground1;
    const casing = theme.colorNeutralStroke1;
    const quiet = theme.colorNeutralStroke2;
    const halo = theme.colorNeutralBackground1;
    const flavor = {
        background: theme.colorNeutralBackground3,
        earth: land,
        park_a: park,
        park_b: park,
        wood_a: park,
        wood_b: park,
        scrub_a: land,
        scrub_b: land,
        hospital: theme.colorPaletteRedBackground2,
        aerodrome: theme.colorNeutralBackground6,
        runway: casing,
        water: theme.colorPaletteBlueBackground2,
        // Not drawn.
        industrial: land, school: land, pedestrian: land, glacier: land, sand: land, beach: land, zoo: land, military: land, pier: land, buildings: land, railway: land,
        tunnel_other_casing: quiet, tunnel_minor_casing: quiet, tunnel_link_casing: quiet, tunnel_major_casing: quiet, tunnel_highway_casing: quiet,
        tunnel_other: road, tunnel_minor: road, tunnel_link: road, tunnel_major: road, tunnel_highway: road,
        minor_service_casing: quiet, minor_casing: quiet, link_casing: casing, major_casing_late: casing, highway_casing_late: casing,
        other: road, minor_service: road, minor_a: road, minor_b: road, link: road,
        major_casing_early: casing, major: road, highway_casing_early: casing, highway: road,
        bridges_other_casing: quiet, bridges_minor_casing: quiet, bridges_link_casing: casing, bridges_major_casing: casing, bridges_highway_casing: casing,
        bridges_other: road, bridges_minor: road, bridges_link: road, bridges_major: road, bridges_highway: road,
        boundaries: theme.colorNeutralForeground4,
        roads_label_minor: theme.colorNeutralForeground3,
        roads_label_minor_halo: halo,
        roads_label_major: theme.colorNeutralForeground2,
        roads_label_major_halo: halo,
        ocean_label: theme.colorPaletteBlueForeground2,
        subplace_label: theme.colorNeutralForeground3,
        subplace_label_halo: halo,
        city_label: theme.colorNeutralForeground1,
        city_label_halo: halo,
        state_label: theme.colorNeutralForeground4,
        state_label_halo: halo,
        country_label: theme.colorNeutralForeground3,
        address_label: theme.colorNeutralForeground3,
        address_label_halo: halo,
    };
    return {
        flavor,
        landmarks: {
            hospital: theme.colorPaletteRedForeground1, airport: theme.colorNeutralForeground2, park: theme.colorPaletteForestForeground2, halo,
            size: Number.parseFloat(theme.fontSizeBase200) - 1, haloWidth: Number.parseFloat(theme.strokeWidthThin),
        },
    };
}
export const mapThemes = Object.freeze({ light: mapThemeOf(lightTheme), dark: mapThemeOf(darkTheme) });
//# sourceMappingURL=mapTheme.js.map